document.addEventListener('DOMContentLoaded', () => {
  // Ativa os botões do accordion
  document.querySelectorAll('.np-accordion-toggle').forEach(button => {
    button.addEventListener('click', () => {
      const id = button.getAttribute('data-id');
      npToggleProductDescriptionAccordion(id);
    });
  });

  // Aguarda até que o primeiro conteúdo correspondente esteja no DOM
  npWaitForAccordionAndInit();
});

function npWaitForAccordionAndInit() {
  const checkInterval = setInterval(() => {
    const buttons = document.querySelectorAll('.np-accordion-toggle');

    for (const button of buttons) {
      const id = button.getAttribute('data-id');
      const content = document.getElementById('pda-content-' + id);

      if (content) {
        npToggleProductDescriptionAccordion(id);
        clearInterval(checkInterval);
        return;
      }
    }

    // Nenhum conteúdo encontrado ainda — segue tentando

  }, 200); // checa a cada 200ms

  // Para de tentar após 5 segundos
  setTimeout(() => clearInterval(checkInterval), 5000);
}

function npToggleProductDescriptionAccordion(id) {
  const content = document.getElementById('pda-content-' + id);
  const icon = document.getElementById('pda-icon-' + id);
  
  if (!content) {
    console.warn(`Elemento com ID "pda-content-${id}" não encontrado.`);
    return;
  }

  const isOpen = content.classList.contains('open');

  // Fecha todos os conteúdos
  document.querySelectorAll('.np-product-description-accordion__content').forEach(el => {
    el.classList.remove('open');
    el.style.maxHeight = null;
  });

  // Fecha todos os ícones
  document.querySelectorAll('.np-product-description-accordion__icon').forEach(el => {
    el.classList.remove('rotate');
  });

  // Abre o conteúdo clicado
  if (!isOpen) {
    content.classList.add('open');
    if (icon) icon.classList.add('rotate');
    requestAnimationFrame(() => {
      content.style.maxHeight = content.scrollHeight + 'px';
    });
  }
}
